import { HttpServices } from './http.services'
import { API_URL } from './config.services'

async function getData(
  param: string,
  country: string,
  type: string,
  user_id: string,
  source: string,
) {
  const data = {
    user_id,
    param,
    type,
    source,
    country,
  }
  return HttpServices.doGet(`${API_URL}/getData`, data)
}

export const dataService = {
  getData,
}
